
export enum KentRecordType  {           
        Monument = "mon",     
        Source = "source",
        Designation = "desig",
        HistoricLandscapeCharacterisation = "hlc",
        AreaBoundary = "bound"
}  

export enum KentRecordSubType  {   
    ConservationArea = "COA",
    ScheduledMonument = "SM",
    HistoricParksAndGardens = "HPG",    
    RegisteredParksAndGardens = "RPG",
    ListedBuilding = "LB"
}  

